import React from 'react';
import PropTypes from "prop-types";
const ProductSelectionView = (props) => {
    const buttonStyles = {
        transform: 'translate(-100%, 0)',
        position: 'absolute',
        left: props.distanceLeft + 'px'
    }

    const getContent = () => {
        if (props.hideList) {
            return (
                <div style={{display: 'flex', alignItems: 'center', marginTop: '10px'}}>
                    <label className={"enabled label_radio category-radio selected"} key={props.productKey}>
                        <img src={props.image} className={"product-category-image "}/>
                        {props.optionText}
                    </label>
                    <a className="button no-chevron" style={buttonStyles}
                       onClick={() => props.handleClick()}>{props.buttonText}</a>
                </div>
            )
        } else {
            return (
                <fieldset className="product-selection-list">
                    {props.options}
                </fieldset>
            )
        }
    }

    return (
        <div className="configurator-step" id="product-wrapper">
            <div className="row">
                <div className="title small-12 medium-2 columns">
                    <label>{props.title}</label>
                </div>
                <div className="selection small-12 medium-10 columns">
                    {getContent()}
                </div>
            </div>
        </div>
    )
}

ProductSelectionView.propTypes = {
    title: PropTypes.string.isRequired,
    distanceLeft: PropTypes.number.isRequired,
    image: PropTypes.string.isRequired,
    productKey: PropTypes.oneOfType([ PropTypes.string, PropTypes.number]),
    handleClick: PropTypes.func.isRequired,
    buttonText: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    hideList: PropTypes.bool.isRequired,
    optionText: PropTypes.string,
    currentValue: PropTypes.object,
}
export default ProductSelectionView;

